/**
 * Smooth scroll dentro de la página (CTA Hero Gold Std → ancla tipo #day-drop-grid).
 */
(function () {
  try {
    if (document.documentElement.dataset.fhgsSmoothScrollBound === '1') return;
    document.documentElement.dataset.fhgsSmoothScrollBound = '1';
  } catch (e0) {}

  document.addEventListener(
    'click',
    function (ev) {
      var el = ev.target && ev.target.closest ? ev.target.closest('[data-fhgs-scroll-target]') : null;
      if (!el) return;
      if (typeof el.closest === 'function' && el.closest('.m-fhgs-root') === null) return;
      if (el.getAttribute('aria-disabled') === 'true') return;

      var raw = el.getAttribute('data-fhgs-scroll-target') || '';
      var id = String(raw).replace(/^#/, '').trim();
      if (!id) return;

      ev.preventDefault();

      try {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          var node = document.getElementById(id);
          if (node) node.scrollIntoView({ block: 'start' });
          try {
            history.replaceState(null, '', '#' + id);
          } catch (e1) {}
          return;
        }
      } catch (e2) {}

      var target = document.getElementById(id);
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try {
        history.replaceState(null, '', '#' + id);
      } catch (e3) {}
    },
    false
  );
})();
